import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'client';

export default (sessionToken, sessionId) => {
  const { t } = useTranslation('labels');
  const queryClient = useQueryClient();
  const updateSessionName = async (name) => {
    const data = { name };
    const config = {
      headers: {
        'Adracare-Session-Token': sessionToken,
        'Adracare-Session-Id': sessionId,
        'Content-Type': 'application/json',
        Authorization: null,
      },
    };
    return api.put(`/apis/v2/direct_video_session_tokens/session_name`, data, config);
  };

  const mutation = useMutation(updateSessionName, {
    onSuccess: () => {
      toast(t('success'));
      return queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'POST' && query.queryKey[1] === `/apis/v2/direct_video_session_tokens`,
      });
    },
    onError: (error) => {
      if (error.response?.data?.message) {
        toast.error(error.response?.data?.message);
      } else if (error.message) {
        toast.error(error.message);
      }
    },
  });

  return {
    updateSessionName: mutation.mutate,
  };
};
